import React, { ReactElement } from 'react';

const Chevron = (): ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 32 24"
      x="0px"
      y="0px"
    >
      <path d="M0,0l0,8.327l16,15.673l2.125,-2.082l13.875,-13.591l0,-8.327l-16,15.673l-16,-15.673Z" />
    </svg>
  );
};

export default Chevron;
